import { IBaseModule, IEnergyFactsSendRecipient, ISearchResult, IEnergyFactsSendRecipientSearchParam } from "@/store/common/Types";
import { Actions, Mutations, Endpoints } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";
import ApiService from "@/core/services/ApiService";

@Module
export default class EnergyFactsSendModule extends VuexModule implements IBaseModule {
    errors = {};
    energyFactsSendRecipient = {} as ISearchResult<IEnergyFactsSendRecipient>;

    /**
     * Get Energy Facts Send Recipient errors
     * @returns array
     */
    get getEnergyFactsSendRecipientErrors() {
      return this.errors;
    }  

    /**
     * Get energy facts send recipient search result
     * @returns ISearchResult<IEnergyFactsSendRecipient>
     */
    get getEnergyFactsSendRecipient() : ISearchResult<IEnergyFactsSendRecipient>{
      return this.energyFactsSendRecipient;
    }  

    @Mutation
    [Mutations.SET_ERROR](error) {
      this.errors = { ...error };
    }

    @Mutation
    [Mutations.SET_ENERGY_FACTS_SEND_RECIPIENT](items: ISearchResult<IEnergyFactsSendRecipient>) {
        this.energyFactsSendRecipient = items;
    } 

    @Action
    [Actions.SEARCH_ENERGY_FACTS_SEND_RECIPIENT](param: IEnergyFactsSendRecipientSearchParam) {      
        if(!param){
            return;
        }   

        let query = "?";
        if (param.energyFactsSendId) {
            query += "energyFactsSendId=" + param.energyFactsSendId;
        }

        ApiService.setHeader();
        return ApiService.get(Endpoints.EnergyFactsSendRecipient, query)
            .then(({ data }) => {
              this.context.commit(Mutations.SET_ENERGY_FACTS_SEND_RECIPIENT, data);
            })
            .catch(({ response }) => {
                if (!response) {
                    this.context.commit(Mutations.SET_ERROR, [
                    "There was an error searching for energy facts send recipient.",
                    ]);
                    return;
                }
                if (response.data && response.data.errors) {
                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
                }
            });
    }

}